import { useMemo } from "react";

import { Checkbox } from "@swivl-mono/ui";
import _ from "lodash";
import { RxTriangleDown, RxTriangleRight } from "react-icons/rx";
import LocationsModel from "../../../../Models/Locations/Locations.Model";
import { ReviewsManagerViewFilterCounts, ReviewsManagerViewFilters } from "../../Helpers/ReviewsViewHelper";
import "./Review.View.Filters.scss";
import { CheckedState } from "@radix-ui/react-checkbox";

interface Props {
  filters: ReviewsManagerViewFilters
  counts: ReviewsManagerViewFilterCounts
  storesWithReviews: number[]
  showAllStores: boolean
  setShowAllStores(showAllStores: boolean): void
  setFilters: (filters: ReviewsManagerViewFilters) => void
}

interface GroupHeadingProps {
  title: string
  filters: ReviewsManagerViewFilters
  setFilters: (filters: ReviewsManagerViewFilters) => void
  group: string[]
  open?: boolean
  setOpen?(open: boolean): void
}

export function ReviewsManagerFiltersGroupHeading(props: GroupHeadingProps) {
  const { title, filters, setFilters, group, open, setOpen } = props
  const anySelected = useMemo(() => {
    return group.some((value) => _.get(filters, value))
  }, [group, filters])

  return <div className="ReviewsManagerFiltersGroupHeading">
    {setOpen ? <label onClick={() => setOpen(!open)}>{open ? <RxTriangleDown /> : <RxTriangleRight />} {title} </label> : <label>{title}</label>}
    {anySelected ? <button onClick={() => {
      const newFilters = { ...filters }
      group.forEach((value) => {
        _.set(newFilters, value, false)
        // newFilters[value] = false
      })
      setFilters(newFilters)
    }} >Clear</button> : <span>All</span>}
  </div>
}

export function ReviewsManagerFiltersView(props: Props) {
  const { filters, counts, setFilters, storesWithReviews } = props
  const { groups } = LocationsModel.useState()

  const updateFilter = (checked: CheckedState, name: string) => {
    setFilters({ ...filters, [name]: checked })
  }

  const updateStoreFilter = (checked: CheckedState, name: string) => {
    setFilters({ ...filters, stores: { ...filters.stores, [name]: checked } })
  }

  return <div className="ReviewsManagerFiltersView">
    <ReviewsManagerFiltersGroupHeading title="Status" filters={filters} setFilters={setFilters} group={["notResponded", "responded"]} />
    <Checkbox
      label={`Haven't Responded (${counts.notResponded})`}
      name={"notResponded"}
      checked={filters.notResponded}
      onCheckedChange={(checked) => updateFilter(checked, "notResponded")}
    />
    <Checkbox
      label={`Responded (${counts.responded})`}
      name={"responded"}
      checked={filters.responded}
      onCheckedChange={(checked) => updateFilter(checked, "responded")}
    />

    <ReviewsManagerFiltersGroupHeading title="Star Rating" filters={filters} setFilters={setFilters} group={["starRating1", "starRating2", "starRating3", "starRating4", "starRating5"]} />
    <Checkbox
      label={`1 Star (${counts.starRating1})`}
      name={"starRating1"}
      checked={filters.starRating1}
      onCheckedChange={(checked) => updateFilter(checked, "starRating1")}
    />
    <Checkbox
      label={`2 Star (${counts.starRating2})`}
      name={"starRating2"}
      checked={filters.starRating2}
      onCheckedChange={(checked) => updateFilter(checked, "starRating2")}
    />
    <Checkbox
      label={`3 Star (${counts.starRating3})`}
      name={"starRating3"}
      checked={filters.starRating3}
      onCheckedChange={(checked) => updateFilter(checked, "starRating3")}
    />
    <Checkbox
      label={`4 Star (${counts.starRating4})`}
      name={"starRating4"}
      checked={filters.starRating4}
      onCheckedChange={(checked) => updateFilter(checked, "starRating4")}
    />
    <Checkbox
      label={`5 Star (${counts.starRating5})`}
      name={"starRating5"}
      checked={filters.starRating5}
      onCheckedChange={(checked) => updateFilter(checked, "starRating5")}
    />

    <ReviewsManagerFiltersGroupHeading title="Provider" filters={filters} setFilters={setFilters} group={["google", "yelp", "apple"]} />
    <Checkbox
      label={`Google (${counts.google})`}
      name={"google"}
      checked={filters.google}
      onCheckedChange={(checked) => updateFilter(checked, "google")}
    />
    <Checkbox
      label={`Spot (${counts.spot})`}
      name={"spot"}
      checked={filters.spot}
      onCheckedChange={(checked) => updateFilter(checked, "spot")}
    />

    <ReviewsManagerFiltersGroupHeading
      title="Stores"
      filters={filters}
      setFilters={setFilters}
      group={[]}
      open={props.showAllStores}
      setOpen={props.setShowAllStores}
    />

    {props.showAllStores && groups && groups.map((group) => {
      return <div key={`group${group.id}`}><label>{group.name}</label>
        {group.locations.map((location) => {
          return <Checkbox
            key={location.id}
            label={`${location.name}  (${counts.stores[location.id] || "0"})`}
            name={location.id.toString()}
            checked={filters.stores[location.id]}
            onCheckedChange={(checked) => updateStoreFilter(checked, location.id.toString())}
          />
        })}
      </div>
    })}
  </div>
}